(function () {
  'use strict';

  angular
    .module('app.blogPostOverview')
    .controller('blogPostOverviewCtrl', blogPostOverviewCtrl);

  blogPostOverviewCtrl.$inject = ['$scope', '$state', 'blogPostOverviewService', '$rootScope', '$http', '$controller', '$stateParams', 'localStorageService', '$modal', '$compile', '$location'];
  /* @ngInject */
  function blogPostOverviewCtrl($scope, $state, blogPostOverviewService, $rootScope, $http, $controller, $stateParams, localStorageService, $modal, $compile, $location) {
    $scope.firstLoad = true;
    $scope.blogPostTitle = null;
    $scope.blogPostUrl = null;
    $scope.relativepath = null;
    $scope.influencerName = null;
    $scope.influencerChannels = null;
    $scope.blogPostHandle = "N/A";
    $scope.blogPostPublishDate = null;
    var allowAddingTag = true;
    var newTagLabel = "";
    $scope.KeywordValidate = true;
    $scope.newMentionList = [];
    $scope.existsMentions = [];
    $scope.deletedMention = [];
    $scope.currentKeywords = [];
    $scope.showCurrentKeywordList = [];
    $scope.currentKeywordsText = "";
    
    var ls = localStorageService;

    var vm = this;

    $scope.timeline = [
        {label: 'Last 7 days', value: 7, ticked: true},
        {label: 'Last 15 days', value: 15},
        {label: 'Last 30 days', value: 30},
        {label: 'Last 60 days', value: 60},
        /*{label: 'Last 90 days', value: 90}*/
    ];

    var pieChartConfig = {
        options: {
          chart: {
            type: 'pie',
            zoomType: 'x',
            marginTop: 16,
            spacingTop: 20
          },
          tooltip: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: false
            }
          },
          
          credits: {
            enabled: false
          }
        },
        series: [{
          size: '80%',
          innerSize: '90%'
        }],
        title: {
          text: '',
          style: {
            fontSize: '16px',
            color: '#4B5567',
            fontWeight: 'bold',
            fontFamily: 'ProximaNovaRegular'
          }
        },
        xAxis: {
          type: 'datetime',
          title: {
            text: 'Date'
          }
        },
        noData: 'Pending Data...',
        loading: true
      };


    var pieChartConfigHaveLegend = {
      options: {
        chart: {
          type: 'pie',
          backgroundColor: null,
          marginBottom: 1,
          marginLeft: 0,
          marginRight: 200,
          marginTop: 15
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            size: 105
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          width: 170,
          itemStyle: {
            fontWeight: '500'
          },
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.round(Math.floor(this.y*1000))/10 +'%' +
              '</span>';}
        }
      },
      series: [{
        size: '80%',
        innerSize: '90%'
      }],
      title: {
        text: 'ENGAGEMENT',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontWeight: 'bold',
          fontFamily: 'ProximaNovaRegular'
        },
        align: 'left'
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'No engagement allocation available',
      loading: true
    };

    vm.activityLineChart = {
        options: {
            chart: {
                type: 'line',
                zoomType: 'x',
                events: {
                    redraw: function(){
                        $('.highcharts-markers').attr('visibility', 'hidden');
                    }
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        symbol: "circle",
                        fillColor: "#fff",
                        lineColor: null,
                        lineWidth: 3,
                        radius: 4,
                        states: {
                            hover: {
                                enabled: true,
                                symbol: "circle",
                                fillColor: "#fff",
                                lineColor: "#000",
                                lineWidth: 3,
                                radius: 4
                            }
                        }
                    },
                    events: {
                        mouseOver: function (event) {
                            this.markerGroup.attr('visibility', 'visible');
                        },
                        mouseOut: function(event) {
                            this.markerGroup.attr('visibility', 'hidden');
                        }
                    }
                }
            },
            tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                    "color": "#FFFFFF",
                    "padding": "6"
                }
            }
        },
        series: [],
        title: {
            text: ''
        },
        xAxis: {
            type: 'datetime',
            labels: {
                useHTML: true,
                format: "{value:%d %b}",
                style: {
                    fontFamily: "ProximaNovaRegular",
                    letterSpacing: "1px",
                    paddingTop: "10px",
                    textTransform: "uppercase",
                }
            },
            tickLength: 0
        },
        yAxis: {
            title: {
                text: null
            },
            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                },
                style:{
                    fontFamily: "ProximaNovaRegular",
                }
            }
        },
        noData: 'Pending Data...',
        loading: true
    };

    function generateBlogpostOverviewLineChart (chartData) {
      var engagementLine = {name: 'Engagement', data: [], color: '#00D6EF'};
      var impressionsLine = {name: 'Impressions', data: [], color: '#55E9A9'};
      var reachLine = {name: 'Reach', data: [], color: '#FF6C9D'};

      angular.forEach(chartData, function (item) {
        engagementLine.data.push([item.date, Math.round(item.engagement)]);
        impressionsLine.data.push([item.date, Math.round(item.impression)]);
        reachLine.data.push([item.date, Math.round(item.reach)]);
      });

      vm.activityLineChart.series = [];               
      vm.activityLineChart.series.splice(0,0,engagementLine);
      vm.activityLineChart.series.splice(0,0,reachLine);
      vm.activityLineChart.series.splice(0,0,impressionsLine);
      vm.activityLineChart.loading = false;        
      $scope.$broadcast('highchartsng.reflow'); 
    }

    function generateKPIs(kPIs) {
        vm.generalKPIs = [
            {label: 'Reach', value:  null},
            {label: 'Engagement', value:  null},
            {label: 'Impact', value: null}
        ];

        /*if(kPIs != null){
          kPIs.reach = (kPIs.reach / 1000000) > 1 ? (Math.floor(kPIs.reach / 1000000)) + 'M' : (kPIs.reach / 1000) > 1 ? (Math.floor(kPIs.reach / 1000)) + 'K' : Math.round(kPIs.reach);
          kPIs.engagement = (kPIs.engagement / 1000000) > 1 ? (Math.floor(kPIs.engagement / 1000000)) + 'M' : (kPIs.engagement / 1000) > 1 ? (Math.floor(kPIs.engagement / 1000)) + 'K' : Math.round(kPIs.engagement);
          kPIs.impact = Math.round(kPIs.impact);
          
        }*/

        /*Fix: Show full number of KPI*/
        if(kPIs != null){
          kPIs.reach = Math.round(kPIs.reach);
          kPIs.engagement = Math.round(kPIs.engagement);
          kPIs.impact = Math.round(kPIs.impact);
        }

        vm.generalKPIs[0].value = kPIs.reach;
        vm.generalKPIs[1].value = kPIs.engagement;
        vm.generalKPIs[2].value = kPIs.impact;
    }

    function generateBlogpostOverviewPieChart (engagement) {
      vm.engagement = {};
      var pieChart = _.get(engagement, 'chartData');
      var config = angular.copy(pieChartConfigHaveLegend);
      config.options.chart.width = 485;
      var dataPieChart = [];
      _.forEach(pieChart, function (item) {
        dataPieChart.push({name: item.name, y: item.percent});      
      });
      config.series[0].data = dataPieChart;
      config.series[0].size = '80%';
      // config.title.text = 'Industries BY INFLUENCERS';
      config.title.style.marginBottom = '16px';
      config.title.x = 25;

      vm.engagement.pieChart = config;

      $scope.$broadcast('highchartsng.reflow');
    }

    function generateTop5PostsInSameInfluencer(top5PostsInSameInfluencer) {

        vm.top5PostsInSameInfluencer = top5PostsInSameInfluencer;

        // 3 pie charts content.pieCharts.impact.pieChartConfig
          var tempConfig = angular.copy(pieChartConfig);
          tempConfig.options.chart = {
            type: 'pie',
            zoomType: 'x',
            backgroundColor: null,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            width: 40,
            height: 40,
            style: {
              "overflow" : "visible"
            }
          };
          tempConfig.options.tooltip = {
            useHTML: true,
            followPointer: false,
            hideDelay: 0,
            backgroundColor: "#333b48",
            headerFormat: "",
            borderRadius: 24,
            borderWidth: 0,
            shadow: false,
            shape: "callout",
            style: {
                "color": "#FFFFFF",
                "padding": "6"
            },
            positioner: function(boxWidth, boxHeight, point) {      
                var chart = this.chart,
                plotLeft = chart.plotLeft,
                plotTop = chart.plotTop,
                plotWidth = chart.plotWidth,
                plotHeight = chart.plotHeight;
                return {x:chart.plotLeft + chart.plotWidth/2 - boxWidth/2, y:chart.plotTop - boxHeight/2 - 20};         
            },
            pointFormatter: function () {
              if(this.name == 'Other'){
                if(this.series.points[0].name == 'Impact') {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                } else {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                }
              } else {
                if(this.name == 'Impact') {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                } else {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                }
              }
            }
          };
          tempConfig.series[0] = {
            size: '31',
            innerSize: '25',
            states: {
              hover: {
                halo: {
                  size: 1
                }
              }
            }
          };

          var item = {};
          _.forEach(top5PostsInSameInfluencer.contents, function (content) {
            item = content.pieCharts;
            // reach
            item.reach.pieChartConfig = angular.copy(tempConfig);
            item.reach.pieChartConfig.series[0].name = item.name;
            item.reach.pieChartConfig.series[0].data = [{name: 'Reach', color: '#FF6C9D', y: _.get(item, 'reach.percent'), value: _.get(item, 'reach.value')},
                                                        {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'reach.percent')), value: _.get(item, 'reach.other')}];

            // engagement
            item.engagement.pieChartConfig = angular.copy(tempConfig);
            item.engagement.pieChartConfig.series[0].name = item.name;
            item.engagement.pieChartConfig.series[0].data = [{name: 'Engagement', color: '#00D6EF', y: _.get(item, 'engagement.percent'), value: _.get(item, 'engagement.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'engagement.percent')), value: _.get(item, 'engagement.other')}];

            // impact
            item.impact.pieChartConfig = angular.copy(tempConfig);
            item.impact.pieChartConfig.series[0].name = item.name;
            item.impact.pieChartConfig.series[0].data = [{name: 'Impact', color: '#4A5568', y: _.get(item, 'impact.percent'), value: _.get(item, 'impact.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'impact.percent')), value: _.get(item, 'impact.other')}];

            item = {};
          });
    }

    function generateTop5PostsInSameTopic(top5PostsSameTopic) {

        vm.top5PostsSameTopic = top5PostsSameTopic;

        // 3 pie charts content.pieCharts.impact.pieChartConfig
          var tempConfig = angular.copy(pieChartConfig);
          tempConfig.options.chart = {
            type: 'pie',
            zoomType: 'x',
            backgroundColor: null,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            width: 40,
            height: 40,
            style: {
              "overflow" : "visible"
            }
          };
          tempConfig.options.tooltip = {
            useHTML: true,
            followPointer: false,
            hideDelay: 0,
            backgroundColor: "#333b48",
            headerFormat: "",
            borderRadius: 24,
            borderWidth: 0,
            shadow: false,
            shape: "callout",
            style: {
                "color": "#FFFFFF",
                "padding": "6"
            },
            positioner: function(boxWidth, boxHeight, point) {      
                var chart = this.chart,
                plotLeft = chart.plotLeft,
                plotTop = chart.plotTop,
                plotWidth = chart.plotWidth,
                plotHeight = chart.plotHeight;
                return {x:chart.plotLeft + chart.plotWidth/2 - boxWidth/2, y:chart.plotTop - boxHeight/2 - 20};         
            },
            pointFormatter: function () {
              if(this.name == 'Other'){
                if(this.series.points[0].name == 'Impact') {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                } else {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                }
              } else {
                if(this.name == 'Impact') {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                } else {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                }
              }
            }
          };
          tempConfig.series[0] = {
            size: '31',
            innerSize: '25',
            states: {
              hover: {
                halo: {
                  size: 1
                }
              }
            }
          };

          var item = {};
          _.forEach(top5PostsSameTopic.contents, function (content) {
            item = content.pieCharts;
            // reach
            item.reach.pieChartConfig = angular.copy(tempConfig);
            item.reach.pieChartConfig.series[0].name = item.name;
            item.reach.pieChartConfig.series[0].data = [{name: 'Reach', color: '#FF6C9D', y: _.get(item, 'reach.percent'), value: _.get(item, 'reach.value')},
                                                        {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'reach.percent')), value: _.get(item, 'reach.other')}];

            // engagement
            item.engagement.pieChartConfig = angular.copy(tempConfig);
            item.engagement.pieChartConfig.series[0].name = item.name;
            item.engagement.pieChartConfig.series[0].data = [{name: 'Engagement', color: '#00D6EF', y: _.get(item, 'engagement.percent'), value: _.get(item, 'engagement.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'engagement.percent')), value: _.get(item, 'engagement.other')}];

            // impact
            item.impact.pieChartConfig = angular.copy(tempConfig);
            item.impact.pieChartConfig.series[0].name = item.name;
            item.impact.pieChartConfig.series[0].data = [{name: 'Impact', color: '#4A5568', y: _.get(item, 'impact.percent'), value: _.get(item, 'impact.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'impact.percent')), value: _.get(item, 'impact.other')}];

            item = {};
          });
    }

    function generateRelatedPosts(relatedPosts) {
      vm.relatedPosts = relatedPosts;
      // 3 pie charts content.pieCharts.impact.pieChartConfig
          var tempConfig = angular.copy(pieChartConfig);
          tempConfig.options.chart = {
            type: 'pie',
            zoomType: 'x',
            backgroundColor: null,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            width: 40,
            height: 40,
            style: {
              "overflow" : "visible"
            }
          };
          tempConfig.options.tooltip = {
            useHTML: true,
            followPointer: false,
            hideDelay: 0,
            backgroundColor: "#333b48",
            headerFormat: "",
            borderRadius: 24,
            borderWidth: 0,
            shadow: false,
            shape: "callout",
            style: {
                "color": "#FFFFFF",
                "padding": "6"
            },
            positioner: function(boxWidth, boxHeight, point) {      
                var chart = this.chart,
                plotLeft = chart.plotLeft,
                plotTop = chart.plotTop,
                plotWidth = chart.plotWidth,
                plotHeight = chart.plotHeight;
                return {x:chart.plotLeft + chart.plotWidth/2 - boxWidth/2, y:chart.plotTop - boxHeight/2 - 20};         
            },
            pointFormatter: function () {
              if(this.name == 'Other'){
                if(this.series.points[0].name == 'Impact') {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',') + '%';
                } else {
                  return this.series.points[0].name + ': ' + Highcharts.numberFormat(this.series.points[0].value, 0, 0, ',');
                }
                
              } else {
                if(this.name == 'Impact') {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',') + '%';
                } else {
                  return this.name + ': ' + Highcharts.numberFormat(this.value, 0, 0, ',');
                }
                
              }
            }
          };
          tempConfig.series[0] = {
            size: '31',
            innerSize: '25',
            states: {
              hover: {
                halo: {
                  size: 1
                }
              }
            }
          };

          var item = {};
          _.forEach(relatedPosts.contents, function (content) {
            item = content.pieCharts;
            // reach
            item.reach.pieChartConfig = angular.copy(tempConfig);
            item.reach.pieChartConfig.series[0].name = item.name;
            item.reach.pieChartConfig.series[0].data = [{name: 'Reach', color: '#FF6C9D', y: _.get(item, 'reach.percent'), value: _.get(item, 'reach.value')},
                                                        {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'reach.percent')), value: _.get(item, 'reach.other')}];

            // engagement
            item.engagement.pieChartConfig = angular.copy(tempConfig);
            item.engagement.pieChartConfig.series[0].name = item.name;
            item.engagement.pieChartConfig.series[0].data = [{name: 'Engagement', color: '#00D6EF', y: _.get(item, 'engagement.percent'), value: _.get(item, 'engagement.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'engagement.percent')), value: _.get(item, 'engagement.other')}];

            // impact
            item.impact.pieChartConfig = angular.copy(tempConfig);
            item.impact.pieChartConfig.series[0].name = item.name;
            item.impact.pieChartConfig.series[0].data = [{name: 'Impact', color: '#4A5568', y: _.get(item, 'impact.percent'), value: _.get(item, 'impact.value')},
                                                             {name: 'Other', color: '#EEF2F4', y: (1-_.get(item, 'impact.percent')), value: _.get(item, 'impact.other')}];

            item = {};
          });
    }

    function getDataBlogPostOverview () {
        getBlogpostOverviewLineChart($scope.blogPostUrlHash, $scope.relativepath,  $scope.blogPostPublishDate);
        getBlogpostOverviewPieChart($scope.blogPostUrlHash, $scope.relativepath);
        getTop5PostsInSameInfluencer($scope.influencer_id, $scope.blogPostUrlHash);
        getTop5PostsInSameTopic($scope.influencer_id, $scope.blogPostUrlHash, $scope.topicId);
        getRelatedPosts($scope.influencer_id, $scope.topicId);
    }

    function getBlogpostOverviewLineChart(url_hash, relativepath, published_date) {
      blogPostOverviewService.getBlogpostOverviewLineChart(url_hash, relativepath, published_date)
        .then(function (data) {
          generateBlogpostOverviewLineChart(data.blogPostOverviewLineChart.chartData);
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    $scope.loadData = function(){
        if($scope.firstLoad){
          $http.get($rootScope.apiUrl + 'blogPost/getBlogpostOverviewData?full_url=' + encodeURIComponent($stateParams.url) + '&relativepath=' + $stateParams.relativepath, {loader: true})
          .success(function(response){
              if(response.blogpostOverviewData != null){
                $scope.blogPostTitle = response.blogpostOverviewData.title;
                $scope.blogPostUrl = decodeURIComponent($stateParams.url);
                $scope.relativepath = response.blogpostOverviewData.relativepath;
                $scope.influencer_id = response.blogpostOverviewData.influencerId;
                $scope.influencerName = response.blogpostOverviewData.influencerName;
                $scope.blogPostPublishDate = response.blogpostOverviewData.publishDate;
                $scope.blogPostImgUrl = response.blogpostOverviewData.image;
                $scope.topicId = response.blogpostOverviewData.topicId;
                $scope.topicName = response.blogpostOverviewData.topicName;
                $scope.blogPostUrlHash = response.blogpostOverviewData.urlHash;
              } else{
                  $scope.influencerName = null;
              }

              getNewPostMentions();
              getChannelByRelativePath();
              getCurrentPostMentions();
              getBlogPostKpi();

              getDataBlogPostOverview();
          }) .error(function (data) {
          })
        }
    }

    function getChannelByRelativePath(){
      var url_getChannelByRelativePath = $rootScope.apiUrl + 'blogpost/getChannelByRelativePath?relativepath=' + encodeURIComponent($scope.relativepath);
      $http.get(url_getChannelByRelativePath, {loader: false})
          .success(function(response){
            if (response.data != null) {
              $scope.blogPostHandle = response.data.handle;
            }
          }) .error(function (data) {
          })
    }

    function getNewPostMentions(){
      var url_getNewPostMentions = $rootScope.apiUrl + 'blogPost/getNewPostMentions?full_url=' + encodeURIComponent($scope.blogPostUrl);
      $http.get(url_getNewPostMentions, {loader: false})
          .success(function(response){
            $scope.newMentionList = response.data;
          }) .error(function (data) {
          })
    }

    function getCurrentPostMentions(){
      var currentMentionsData = {
          blog_post_url: $scope.blogPostUrl,
          relativepath: $scope.relativepath
      }

      var req = {
          url: $rootScope.apiUrl + 'blogPost/getCurrentPostMentions',
          method: 'POST',
          data: JSON.stringify(currentMentionsData)
      }
      $http(req).success(function (response) {
          //update list of current mentions
          $scope.currentKeywords = response.data;
        
          $scope.newMentionList.forEach(function(newKw){
            if($scope.currentKeywords.indexOf(newKw.keyword_id.keyword) < 0){
                $scope.currentKeywords.push(newKw.keyword_id.keyword);
            }
          })

          var count = 0;
          var combinedText = "";
          $scope.currentKeywords.forEach(function(kw){
            if(kw != "null" && kw != null){
              combinedText = combinedText + kw;
              if(count < $scope.currentKeywords.length-1){
                  combinedText = combinedText + "\n";
              }
              count += 1;
            }            
          })
          $scope.currentKeywordsText = combinedText;

      })
      .error(function (response) {

      });
    } 

    function getBlogPostKpi(){
        var currentMentionsData = {
            blog_post_url: $scope.blogPostUrl,
            relativepath: $scope.relativepath
        }

        var req = {
            url: $rootScope.apiUrl + 'blogPost/getBlogPostKpi',
            method: 'POST',
            data: JSON.stringify(currentMentionsData)
        }

        $http(req).success(function (response) {
            generateKPIs(response.data);
        })
        .error(function (response) {

        });
    }

    $scope.unexistingClick = function(tagToDefine, $event) {
        var unexistingMention = $event.target;
        var typeid = null;
        var tagElement = unexistingMention.parentElement;
        var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
        if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 1;
        } else if(DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") != 0){
          typeid = 2;
        } else if(!DomainPatter.test(tagToDefine) && tagToDefine.indexOf("#") == 0){
          typeid = 3;
        }

        $rootScope.newMentionModalHandler(tagToDefine, typeid, 0, function(newMention){
            if(newMention){
                var newSpan = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                $(tagElement).find('.unexisting').remove();
                $(tagElement).find('.questionMention').remove();
                $(tagElement).append(newSpan);
                $scope.existsMentions.push(newMention);
            } else {
                console.log('cancel');
            }
        });
    };
    
    setTimeout(function () {
        $(".mentions").tagit({
            allowDuplicates: false,
            allowSpaces: true,
            removeConfirmation: true,
            caseSensitive: false,
            placeholderText: "Add new mention - Enter here", 
            tagLimit: 1,
            //availableTags: availableTags(),

            beforeTagAdded: function (event, ui) {
                var typeid = null;
                if($scope.KeywordValidate){
                    if(ui.tagLabel.split(' ').length >= 3){
                        $('#blogPostKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Keyword is not valid, should input only 1 or 2 words and not be URL or Hashtag(#)</div>', html: true});
                        $('#blogPostKeywords').popover('show');
                        event.stopPropagation();
                        return false;
                    }
                    $('#blogPostKeywords').popover('destroy');
                }
                return true;
            },
            onTagClicked: function (event, ui) {
            },
            afterTagAdded: function (event, ui) {
                var isNewTag = false;
                var id = 0;
                var label = encodeURIComponent(ui.tagLabel);
                $http.get($rootScope.apiUrl + "mention/existingMentionDiscover?mention=" + label, {loader: false}).
                    success(function (response) {
                        id = response.data.id;
                        if (id == null) {
                            isNewTag = true;
                            newTagLabel = ui.tagLabel;
                            if (newTagLabel.indexOf('\'') >= 0) {
                                newTagLabel = newTagLabel.slice(0, newTagLabel.indexOf('\'')) + "\\" + newTagLabel.slice(newTagLabel.indexOf('\''));
                            }
                        } else if (id > 0) {
                            isNewTag = false;
                            ui.tag.children(".tagit-label").get(0).text = response.data.keyword;
                            var existMention = {
                                id: response.data.id,
                                keywordType: response.data.keywordType.id,
                                keyword: response.data.keyword
                            }
                            $scope.existsMentions.push(existMention);
                            /*if($scope.currentKeywords.indexOf(existMention.keyword) >= 0){
                                var keyword = existMention.keyword;
                                $('.tagit-label:contains(\'' +keyword + '\')').parent().addClass("hide");
                            }*/
                        }

                        if(isNewTag){
                            var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + newTagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                            newMention.insertBefore(ui.tag.children().last());
                        } else {
                            if(response.data.approved == 2){
                                var newMention = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                newMention.insertBefore(ui.tag.children().last());
                            }
                        }

                    }).error(function (response) {
                        alert("We cannot get info about this keyword, please try again...")
                        console.log(response.data);
                    });
            },
            beforeTagRemoved: function(event, ui) {
                
            },
            afterTagRemoved: function (event, ui) {
                var delteIndex = -1;
                if($scope.existsMentions != null && $scope.existsMentions != undefined){
                    $scope.existsMentions.forEach(function(val){
                        if(val.keyword == ui.tagLabel){
                            delteIndex = $scope.existsMentions.indexOf(val);
                        }
                    })
                }
                if(delteIndex != -1)
                {
                    $scope.existsMentions.splice(delteIndex,1);
                }
            }
        });
    }, 500);

    $scope.addNewPostMentions = function () {
        if($("#blogPostKeywords").find(".unexisting").length > 0) {
            var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "There is a New Mentions that does not exist in the system. Cannot add to Blog Post.";
            event.stopPropagation();
            return;
        } 

        if($("#blogPostKeywords").find(".txt-waitapprove").length > 0) {
            var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = "There is a New Mentions that is not approved in the system. Cannot add to Blog Post.";
            event.stopPropagation();
            return;
        } 
        
        // add/update mentions for blog post
        var newMention = null;
        if($scope.currentKeywords.indexOf($scope.existsMentions[0].keyword) >= 0){
            var errorModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                windowClass: 'modal-dialog-mention-error'
            });
            $scope.errorModalInstance = errorModalInstance;
            $scope.errorMessage = "This mention is existing in this Blog Post.";
            event.stopPropagation();
            return;
        } else{
            newMention = $scope.existsMentions[0].id;
        }

        

        var data = {
            blog_post_url: $scope.blogPostUrl,
            keywords: newMention,
            published_date: $scope.blogPostPublishDate,
            relativepath: $scope.relativepath,
            url_hash: $scope.blogPostUrlHash,
            appear: 1
        }

        var req = {
            url: $rootScope.apiUrl + 'blogPost/addNewBlogPostMentions',
            method: 'POST',
            data: JSON.stringify(data)
        }

        $http(req).success(function (response) {
            //update list of new mentions with the new data
            $scope.currentKeywordsText = $scope.currentKeywordsText + "\n" + $scope.existsMentions[0].keyword;
            $scope.newMentionList = response.data;
            $("#blogPostKeywords").tagit("removeAll"); 
        })
        .error(function (response) {
            var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
        });          
    }


  function getBlogpostOverviewPieChart(url, relativepath) {
      blogPostOverviewService.getBlogpostOverviewPieChart(url, relativepath)
        .then(function (data) {
          generateBlogpostOverviewPieChart(data.blogpostOverviewPieChart);
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getTop5PostsInSameInfluencer(influencer_id, url_hash) {
      blogPostOverviewService.getTop5PostsInSameInfluencer(influencer_id, url_hash)
        .then(function (data) {
          generateTop5PostsInSameInfluencer(data.top5PostsInSameInfluencer);
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getTop5PostsInSameTopic(influencer_id, url_hash, topic_id) {
      blogPostOverviewService.getTop5PostsInSameTopic(influencer_id, url_hash, topic_id)
        .then(function (data) {
          generateTop5PostsInSameTopic(data.top5PostsInSameTopic);
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getRelatedPosts(influencer_id, topic_id) {
      blogPostOverviewService.getRelatedPosts(influencer_id, topic_id)
        .then(function (data) {
          generateRelatedPosts(data.relatedPosts);
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    $scope.influencerOverviewPage = function(influencer_id){
      $rootScope.previousPage = $location.absUrl();
        $state.transitionTo('home.influencerOverview', {influencer_id: influencer_id}, {
            reload: false,
            inherit: true,
            notify: true
        });
    }

    $scope.postOverviewPage = function(index){
      $rootScope.previousPagePost = $location.absUrl();
        var url_getPlatform = $rootScope.apiUrl + 'overview/getPlatFormPostByRelativepath?relativepath=' + index.relativepath;
        $http.get(url_getPlatform)
            .success(function (response) {
                if (response.data == 1) {
                    $state.transitionTo('home.blogPostOverview', {url: index.url}, {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                    // module = 'home.blogPostOverview';
                } else if (response.data == 2) {
                    $state.transitionTo('home.instagramPostOverview', {url: index.url}, {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                    // module = 'home.instagramPostOverview';
                } else if (response.data == 6) {
                    $state.transitionTo('home.youtubePostOverview', {url: index.url}, {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                    // module = 'home.youtubePostOverview';
                } else if (response.data == 7) {
                    $state.transitionTo('home.facebookPostOverview', {url: index.url}, {
                        reload: false,
                        inherit: true,
                        notify: true
                    });
                }
        })
    }

    $scope.backPost= function(){
        $rootScope.previousPageOfActivityPage = $location.absUrl();
        $rootScope.previousPage = $location.absUrl();
        window.location.href = $rootScope.previousPagePost;

    }

    $scope.addPostToProject = function()
    {
        var addPostToProjectModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/blogPostOverview/addPostToProject/addPostToProject.html?app_v=deployDate',
            controller: 'addPostToProjectCtrl'
        });
        $scope.addPostToProjectModalInstance = addPostToProjectModalInstance;
        $scope.addPostToProjectType = 0;
        $scope.postUrlHash = $scope.blogPostUrlHash;
        $scope.postRelativePath = $scope.relativepath;
    }

    $scope.addPostToCampaign = function() {
      var addPostToCampaignModalScope = $rootScope.$new();
      addPostToCampaignModalScope.urlHash = $scope.blogPostUrlHash;

      var addPostToCampaignModalInstance = $modal.open({
          scope: addPostToCampaignModalScope,
          templateUrl: 'app/blogPostOverview/addPostToCampaigns/addPostToCampaigns.html?app_v=deployDate',
          controller: 'addPostToCampaignsCtrl'
      });

      $scope.addPostToCampaignModalInstance = addPostToCampaignModalInstance;
    }

    // first initiating
    $scope.loadData();
  }
})();